module.exports = __webpack_public_path__ + "img/link-arrow.f1c40e7e.png";